export class RecordingError extends Error {
  constructor(code: string) {
    super(`${getRecordingErrorMessage(code)} (code ${code})`);
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

function getRecordingErrorMessage(code: string) {
  switch (code) {
    case '85983281':
      return 'Recording already exists.';
    case '85983287':
      return 'User does not have permission to create a recording.';
    case '85983305':
      return 'The program does not support recording.';
    case '85983285':
      return 'The channel media file does not support recording.';
    case '85983282':
    case '85983274':
      return 'Insufficient storage space.';
    default:
      return 'Unknown error';
  }
}
